module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DefaultButton', {
    class: {
      withText: !_vm.iconOnly
    },
    attrs: {
      "width": _vm.width,
      "height": _vm.height,
      "background-color": _vm.backgroundColor,
      "text-color": _vm.textColor,
      "disabled": _vm.disabled
    },
    on: {
      "click": function (e) { return !_vm.disabled && _vm.$emit('click', e); }
    }
  }, [_c('span', {
    staticClass: "iconOuter"
  }, [_c('i', {
    staticClass: "icon"
  }, [_vm._t("icon")], 2)]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8cc0f182","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forecasts/elements/form/IconButton.vue
// module id = 3307
// module chunks = 0